import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "py-10 bg-gray-50 flex-grow" }
const _hoisted_3 = { class: "px-4 sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "w-full max-w-md mx-auto bg-white rounded-2xl p-6 md:p-8 shadow-[0_12px_36px_rgba(0,0,0,0.12)] border border-slate-100" }
const _hoisted_5 = { class: "flex flex-col gap-4" }
const _hoisted_6 = { class: "flex flex-col gap-1.5" }
const _hoisted_7 = { class: "relative flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs font-semibold text-rose-500 mt-0.5 ml-1"
}
const _hoisted_9 = { class: "flex flex-col gap-1.5" }
const _hoisted_10 = { class: "relative flex items-center" }
const _hoisted_11 = ["type"]
const _hoisted_12 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_13 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_14 = {
  key: 0,
  class: "text-xs font-semibold text-rose-500 mt-0.5 ml-1"
}
const _hoisted_15 = { class: "flex flex-col gap-1.5" }
const _hoisted_16 = { class: "relative flex items-center" }
const _hoisted_17 = ["type"]
const _hoisted_18 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_19 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.8",
  stroke: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_20 = {
  key: 0,
  class: "text-xs font-semibold text-rose-500 mt-0.5 ml-1"
}
const _hoisted_21 = {
  key: 0,
  class: "text-xs font-semibold text-rose-500 text-center mt-2"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "animate-spin h-5 w-5 text-white",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { onMounted, ref } from 'vue'
import TopBar from '@/components/account/TopBar.vue'
import SideBar from '@/components/account/SideBar.vue'
import { checkUserPasswordSetup, handleApiError, updateAuthUser, resetErrors, isLoggedIn } from '@/utils/common'
import Modal from '@/widgets/Modal.vue'
import Auth from '@/composables/Auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const sidebarOpen = ref<boolean>(false)
const openModal = ref<boolean>(false)
const showNew = ref<boolean>(false)
const showRepeat = ref<boolean>(false)
const isLoading = ref<boolean>(false)
const error = ref<string>('')
const { setupPassword }  = Auth()
const form = ref<any>({
   email: { value: '', error: false, errorMessage: '' },
   password: { value: '', error: false, errorMessage: '' },
   passwordConfirmation: { value: '', error: false, errorMessage: '' }
})

const handleSideBarOpen = () => {
   sidebarOpen.value = true
}

const updatePassword = async () => {

   const isValid = validateForm()
   if (isValid) {

      isLoading.value = true
      const response = await setupPassword(
         form.value.password.value as string, 
         form.value.passwordConfirmation.value as string,
         form.value.email.value as string
      )
      isLoading.value = false

      if (response.status == 200) {
         updateAuthUser(response.data.user)
         openModal.value = false
      } else {
         error.value = handleApiError(response)
      }
   }
}

const validateForm = () : boolean => {

   let response = true
   form.value.email.error = false
   form.value.password.error = false
   form.value.passwordConfirmation.error = false

   if (form.value.email.value == '') {
      form.value.email.error = true
      form.value.email.errorMessage = 'Required'
      response = false
   } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(form.value.email.value)) {
         form.value.email.error = true
         form.value.email.errorMessage = 'Please enter a valid email'
         response = false
      }
   }

   if (form.value.password.value == '') {
      form.value.password.error = true
      form.value.password.errorMessage = 'Required'
      response = false
   }

   if (form.value.passwordConfirmation.value == '') {
      form.value.passwordConfirmation.error = true
      form.value.passwordConfirmation.errorMessage = 'Required'
      response = false
   }
   
   if (form.value.password.value != '' && form.value.password.value.length < 6) {
      form.value.password.error = true
      form.value.password.errorMessage = 'Must be at least 6 characters long'
      response = false
   } else if (form.value.password.value != '' && form.value.passwordConfirmation.value != '' && form.value.password.value != form.value.passwordConfirmation.value) {
      form.value.passwordConfirmation.error = true
      form.value.passwordConfirmation.errorMessage = 'Password confirmation is not the same as password'
      response = false
   }

   return response
}

onMounted(() => {

   const hasSetupPassword = checkUserPasswordSetup()

   if (hasSetupPassword === 0) {
      openModal.value = true
      const authUser = isLoggedIn()
      if (authUser && authUser.user) {
         form.value.email.value = authUser.user.email || ''
      }
   }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TopBar, { onOpenSidebar: handleSideBarOpen }),
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "content")
        ])
      ])
    ]),
    _createVNode(Modal, {
      show: openModal.value,
      canClose: false
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex flex-col items-center text-center mb-6" }, [
            _createElementVNode("div", { class: "h-12 w-12 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-600 mb-4 ring-8 ring-emerald-50/50" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "stroke-width": "1.8",
                stroke: "currentColor",
                class: "w-6 h-6"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                })
              ])
            ]),
            _createElementVNode("h2", { class: "text-xl font-bold text-slate-800" }, "Setup your account"),
            _createElementVNode("p", { class: "text-sm text-slate-500 mt-1" }, "Please set your email and a secure password to complete your account setup.")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-xs font-semibold text-slate-500 uppercase tracking-wider" }, "Email Address", -1)),
              _createElementVNode("div", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "absolute left-3.5 text-slate-400" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.8",
                    stroke: "currentColor",
                    class: "w-5 h-5"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                    })
                  ])
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email.value) = $event)),
                  type: "email",
                  placeholder: "yourname@company.com",
                  class: "w-full bg-slate-50 border border-slate-200 rounded-xl pl-11 pr-4 py-3 text-slate-800 font-semibold outline-none transition-all focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-50 text-[15px]"
                }, null, 512), [
                  [_vModelText, form.value.email.value]
                ])
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-[11px] font-semibold text-rose-500 leading-tight mt-1 ml-1" }, " * Note: You cannot change this email again. Please use your primary business email address here, as this email ID will be used for further communication. ", -1)),
              (form.value.email.error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(form.value.email.errorMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-xs font-semibold text-slate-500 uppercase tracking-wider" }, "New Password", -1)),
              _createElementVNode("div", _hoisted_10, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "absolute left-3.5 text-slate-400" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.8",
                    stroke: "currentColor",
                    class: "w-5 h-5"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M15.75 5.25a3 3 0 013 3m3 0a3 3 0 01-3 3m-3-3a3 3 0 00-3-3m-12 13.5h3.75a1.125 1.125 0 01.796.329l1.988 1.988a1.125 1.125 0 001.59 0l1.988-1.988a1.125 1.125 0 01.796-.329H21"
                    })
                  ])
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password.value) = $event)),
                  type: showNew.value ? 'text' : 'password',
                  placeholder: "••••••••",
                  class: "w-full bg-slate-50 border border-slate-200 rounded-xl pl-11 pr-11 py-3 text-slate-800 font-semibold outline-none transition-all focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-50 text-[15px]"
                }, null, 8, _hoisted_11), [
                  [_vModelDynamic, form.value.password.value]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showNew.value = !showNew.value)),
                  class: "absolute right-3 p-1.5 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
                }, [
                  (!showNew.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _cache[8] || (_cache[8] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M2.036 12.322a1.012 1.012 0 010-.644C3.423 7.51 7.36 5 12 5c4.64 0 8.577 2.51 9.964 6.678.07.214.07.45 0 .644C20.577 16.49 16.64 19 12 19c-4.64 0-8.577-2.51-9.964-6.678z"
                        }, null, -1),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_13, _cache[9] || (_cache[9] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.815 7.815L21 21m-3.955-3.955l-3.32-3.32m0 0a3 3 0 11-4.243-4.243m4.242 4.242L9.88 9.88"
                        }, null, -1)
                      ])))
                ])
              ]),
              (form.value.password.error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(form.value.password.errorMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-xs font-semibold text-slate-500 uppercase tracking-wider" }, "Repeat Password", -1)),
              _createElementVNode("div", _hoisted_16, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "absolute left-3.5 text-slate-400" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.8",
                    stroke: "currentColor",
                    class: "w-5 h-5"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M15.75 5.25a3 3 0 013 3m3 0a3 3 0 01-3 3m-3-3a3 3 0 00-3-3m-12 13.5h3.75a1.125 1.125 0 01.796.329l1.988 1.988a1.125 1.125 0 001.59 0l1.988-1.988a1.125 1.125 0 01.796-.329H21"
                    })
                  ])
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.passwordConfirmation.value) = $event)),
                  type: showRepeat.value ? 'text' : 'password',
                  placeholder: "••••••••",
                  class: "w-full bg-slate-50 border border-slate-200 rounded-xl pl-11 pr-11 py-3 text-slate-800 font-semibold outline-none transition-all focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-50 text-[15px]"
                }, null, 8, _hoisted_17), [
                  [_vModelDynamic, form.value.passwordConfirmation.value]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showRepeat.value = !showRepeat.value)),
                  class: "absolute right-3 p-1.5 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
                }, [
                  (!showRepeat.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _cache[12] || (_cache[12] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M2.036 12.322a1.012 1.012 0 010-.644C3.423 7.51 7.36 5 12 5c4.64 0 8.577 2.51 9.964 6.678.07.214.07.45 0 .644C20.577 16.49 16.64 19 12 19c-4.64 0-8.577-2.51-9.964-6.678z"
                        }, null, -1),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_19, _cache[13] || (_cache[13] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.815 7.815L21 21m-3.955-3.955l-3.32-3.32m0 0a3 3 0 11-4.243-4.243m4.242 4.242L9.88 9.88"
                        }, null, -1)
                      ])))
                ])
              ]),
              (form.value.passwordConfirmation.error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(form.value.passwordConfirmation.errorMessage), 1))
                : _createCommentVNode("", true)
            ]),
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: updatePassword,
              disabled: isLoading.value,
              class: "w-full mt-4 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white font-semibold py-3.5 px-6 rounded-xl flex items-center justify-center gap-2.5 transition-all shadow-sm shadow-emerald-600/10 active:scale-[0.99] cursor-pointer"
            }, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_23, _cache[16] || (_cache[16] = [
                    _createElementVNode("circle", {
                      class: "opacity-25",
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4"
                    }, null, -1),
                    _createElementVNode("path", {
                      class: "opacity-75",
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    }, null, -1)
                  ])))
                : _createCommentVNode("", true),
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "uppercase tracking-wider text-sm font-bold" }, "Update Password", -1))
            ], 8, _hoisted_22)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})